import { Region } from "regionalisation/domain"
import {
  fromCode,
  UnknownRegionCodeError
} from "regionalisation/features/getRegion"

export interface Release {
  isLiveIn: (region: Region) => boolean
}

export class ReleasedEverywhere implements Release {
  isLiveIn = (): boolean => true
}

export class ReleasedNowhere implements Release {
  isLiveIn = (): boolean => false
}

export class RegionalRelease implements Release {
  private readonly regions: Region[]

  constructor(regions: Region[]) {
    this.regions = regions
  }

  isLiveIn = (region: Region): boolean =>
    this.regions.some(released => released.sameAs(region))
}

export class ReleaseFactory {
  fromFlagValue = (value: unknown): Release => {
    const text = `${value ?? ``}`.trim().toLowerCase()

    if (text === `true`) {
      return new ReleasedEverywhere()
    } else if (text === `` || text === `false`) {
      return new ReleasedNowhere()
    } else {
      return new RegionalRelease(this.regionsFrom(text))
    }
  }

  private regionsFrom = (text: string): Region[] =>
    text
      .split(`,`)
      .map(code => code.trim())
      .filter(Boolean)
      .map(code => fromCode(code))
}

export class FailClosedReleaseFactory {
  private readonly releases = new ReleaseFactory()

  fromFlagValue = (value: unknown): Release => {
    try {
      return this.releases.fromFlagValue(value)
    } catch (error) {
      if (error instanceof UnknownRegionCodeError) {
        return new ReleasedNowhere()
      } else {
        throw error
      }
    }
  }
}

export interface ReleaseReadModel {
  getByName: (flagName: string) => Release
}
